import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { Modal } from "@/components/Interface/Modal/Modal";
import { useIsMobile } from "@/hooks/useIsMobile";
import { showsBillingActionBlockedModalAtom } from "@/utils/atoms";

/** Vertragskonto changes are blocked by Compax; the session stays valid. */
export const BillingActionBlockedModal = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [show, setShow] = useAtom(showsBillingActionBlockedModalAtom);

  if (!show) {
    return null;
  }

  const close = () => setShow(false);

  return (
    <Modal
      title={t("billingActionBlocked.title")}
      variant="dark"
      hasScroll={false}
      onClose={close}
    >
      <div>
        <p className="mb-4">{t("billingActionBlocked.text")}</p>
        <div className="flex justify-end">
          <Button
            dataTestid="billing-action-blocked-close"
            variant="primary"
            inverted
            fullWidth={isMobile}
            onClick={close}
          >
            {t("Common.label.gotIt")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
